import { render, staticRenderFns } from "./SVars.vue?vue&type=template&id=103d44ea&"
import script from "./SVars.vue?vue&type=script&lang=js&"
export * from "./SVars.vue?vue&type=script&lang=js&"
import style0 from "./SVars.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports